class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  // addFreeGift() {
  //   fetch(window.Shopify.routes.root + 'cart.js', {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     })
  //     .then(response => {
  //       return response.json();
  //     })
  //     .then(cart => {
  //     const cartTotal = cart.total_price;
  //     console.log(cartTotal);
  //   })
  // }

  renderContents(parsedState) {
    // console.log('render contents', parsedState)
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();


    /* Custom: gift product auto-add */
    const cart = document.querySelector('cart-drawer .mini-cart');
    const giftProductId = parseInt(cart.dataset.giftid);
    const giftThreshold = parseInt(cart.dataset.giftthreshold);
    
    async function handleGiftProduct() {
      if (!giftProductId || !giftThreshold) {
        console.error('Gift product ID or threshold not found in cart data.');
        return;
      }
    
      try {
        const cartData = await fetchCartData();
        const giftItem = cartData.items.find(item => item.id === giftProductId);
        const giftQuantity = giftItem ? giftItem.quantity : 0;
        const cartTotal = cartData.total_price;
    
        if (giftQuantity === 0 && cartTotal >= giftThreshold) {
          await addToCart(giftProductId);
        }
      } catch (error) {
        console.error('Error fetching or updating cart:', error);
      }
    }
    
    async function fetchCartData() {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      return await cartResponse.json();
    }
        
    async function addToCart(productId) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const miniCart = document.querySelector('mini-cart');

      const formData = new FormData();
      formData.append('items[0][id]', productId);
      formData.append('items[0][quantity]', 1);
  
      if (miniCart) {
        formData.append('sections', miniCart.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
  
      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
  
          if (miniCart) {
            miniCart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
        });
      
    }
    
    
    handleGiftProduct();
    
  }




    // const config = fetchConfig('javascript');
    // config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // delete config.headers['Content-Type'];

    // const formData = {
    //   items: [{
    //     id: productId,
    //     quantity: 1
    //   }]
    // };

    // if (this.miniCart) {
    //   formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id));
    // }
    // formData.append('sections_url', window.location.pathname);
    // config.body = formData;

    // fetch(`${window.routes.cart_add_url}`, config)
    //   .then((response) => response.json())
    //   .then((response) => {
    //     if (response.status) {
    //       this.handleErrorMessage(response.description);
    //       return;
    //     }

    //     if (this.miniCart) {
    //       this.miniCart.renderContents(response);
    //     }
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   })
    //   .finally(() => {
    //   });

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
